<div class="messages-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 margin-align">
    <h4 class="margin-header-align text-uppercase">{{ 'messages.page-title' | translate }}</h4>
    <hr />
  </div>
  <i
    *ngIf="!isLoading && !showTechnicianForm && tabsData.length"
    (click)="sortMessagesData()"
    class="ui-sortable-column-icon pi pi-fw icon-position"
    [pTooltip]="(this.isDescOrder ? 'messages.sort-new-message' : 'messages.sort-old-message') | translate"
    [class]="isDescOrder ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down'"></i>
  <div *ngIf="!showTechnicianForm" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <p-tabView (onChange)="updateMessage($event.index)" *ngIf="!isLoading && tabsData.length" [activeIndex]="tabIndex">
      <p-tabPanel *ngFor="let data of tabsData">
        <ng-template pTemplate="header">
          <div>
            <div [class.tabpanel-header]="data.message_read === '0'" class="text-overflow-ellipsis">{{ data.message_title }}</div>
            <div class="header-date">{{ data.message_date | stringifiedDate }}</div>
          </div>
        </ng-template>
        <div>
          <div class="content-header">
            <div class="header-text">{{ data.message_title }}</div>
            <div class="header-date">{{ data.message_date | stringifiedDate }}</div>
          </div>
          <div class="content-message" [innerHTML]="data.message_text"></div>
        </div>
      </p-tabPanel>
    </p-tabView>

    <div *ngIf="!isLoading && !tabsData.length" class="no-data-available">
      {{ 'messages.no-messages' | translate }}
    </div>
  </div>

  <div *ngIf="showTechnicianForm && messageFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 content-section">
    <form [formGroup]="messageFG">
      <div class="form-section">
        <div class="ui-g-12 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 radio-button-section">
          <div *ngIf="!technicianId" class="ui-g-12 form-row no-padding">
            <label class="field-label text-right-align ui-g-4 required">{{ 'messages.at-label' | translate }}</label>
          </div>
          <div *ngIf="!technicianId" class="ui-g-12 form-row no-padding">
            <label class="field-label text-right-align ui-g-4"></label>
            <div class="column-align">
              <p-radioButton
                formControlName="userType"
                id="technician-radio-button"
                label="{{ 'messages.installer-checkbox' | translate }}"
                class="radio-field"
                name="addressedToGroup"
                value="technician"></p-radioButton>

              <p-radioButton
                *ngIf="environmentService.showAllCustomerRadioOption"
                formControlName="userType"
                id="customer-radio-button"
                label="{{ 'messages.customer-checkbox' | translate }}"
                class="radio-field"
                name="addressedToGroup"
                value="customer"></p-radioButton>
            </div>
          </div>

          <div *ngIf="technicianId" class="ui-g-12 form-row">
            <label class="field-label text-right-align ui-g-4">{{ 'messages.first-name' | translate }}</label>
            <input class="ui-input pInputText" formControlName="firstName" pInputText />
          </div>

          <div *ngIf="technicianId" class="ui-g-12 form-row">
            <label class="field-label text-right-align ui-g-4">{{ 'messages.last-name' | translate }}</label>
            <input class="ui-input pInputText" formControlName="lastName" pInputText />
          </div>

          <div class="ui-g-12 form-row">
            <label class="field-label text-right-align ui-g-4"></label>
            <p-checkbox
              appEnterClick
              formControlName="sendEmail"
              value="true"
              binary="true"
              [label]="'messages.customer-send-email-checkbox' | translate"></p-checkbox>
          </div>
        </div>
        <div class="ui-g-12 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 column-align message-input-section">
          <div class="ui-g-12" [class.title-form-row]="!showTechnicianForm" [class.form-row]="showTechnicianForm">
            <label class="field-label ui-g-3 no-padding-left required">{{ 'messages.message-title' | translate }}</label>
            <div class="ui-g-10 no-padding-right">
              <input class="ui-input pInputText title-field" formControlName="title" pInputText />
            </div>
          </div>
          <ng-container *ngIf="environmentService.showWordFormat">
            <quill-editor
              [styles]="editorStyle"
              placeholder="Enter Text"
              formControlName="message"
              [modules]="quillConfig"
              tabindex="0"
              appEnterClick></quill-editor>
          </ng-container>
          <ng-container *ngIf="!environmentService.showWordFormat">
            <textarea class="ui-g-12 ui-inputText" formControlName="message" rows="15"></textarea>
          </ng-container>
        </div>

        <ng-container *ngIf="documents?.controls?.length">
          <div class="ui-g-12 documents-section-header">
            <label class="field-label ui-g-4">{{ 'messages.document-name' | translate }}</label>
          </div>
          <div
            *ngFor="let item of documents.controls; let i = index"
            class="form-background top-bottom-margin flex-row"
            formArrayName="documents">
            <div [formGroupName]="i" class="ui-g-12">
              <div class="ui-g-8 ui-xl-8 ui-lg-8 ui-md-10 ui-sm-12 ui-xs-12 form-rows">
                <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12">
                  <input class="doc-submit-inputs" formControlName="documentName" pInputText type="text" />
                </div>
                <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
                  <p-fileUpload
                    #documentUploader
                    (onSelect)="onImageUpload($event, i, documentUploader)"
                    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
                    mode="basic"></p-fileUpload>
                </div>
              </div>

              <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-2 ui-sm-2 ui-xs-2 field-rows file-name-section">
                <a
                  *ngIf="item.value['fileName']"
                  href="javascript:void(0)"
                  [id]="item.value['documentId']"
                  (click)="downloadDocument(item.value['documentId'], item.value['fileName'])">
                  {{ item.value['fileName'] }}
                </a>
                <i (click)="removeDocument(i)" class="pi pi-trash pointer-cursor padding-left-1"></i>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="ui-g-12 margin-align add-button-row form-font-size">
          <i class="pi pi-plus plus-icon add-document-icon" id="add-document" (click)="addForm()" tabindex="0" appEnterClick></i>
          <label class="ui-g-3 field-label" for="add-document">{{ 'facilities-data.form-fields.add-document-button' | translate }}</label>
        </div>
        <div class="text-right-align top-margin">
          <button
            (click)="confirmSendMessage()"
            [disabled]="messageFG.invalid"
            label="{{ 'send-button-label' | translate }}"
            pButton
            tabindex="0"
            appEnterClick></button>
        </div>
      </div>

      <p-confirmDialog #confirmDialog message="{{ 'messages.confirmation-text' | translate }}" styleClass="netz-confirm-dialog">
        <p-footer>
          <button (click)="confirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
          <button (click)="confirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
        </p-footer>
      </p-confirmDialog>
    </form>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
